import { RootState } from '../store';

export const selectManagerOptions = (state: RootState) => state.manager.managerOptions;

export const selectManagerOptionsRequestStatus = (state: RootState) => state.manager.managerOptionsRequestStatus;
